import { useEffect, useState } from 'react';

import { View } from '../../primitives/View';

/**
 * Web: a polite live region that is mounted EMPTY and filled a tick later —
 * a status region announces a change to its content, not content it was
 * inserted with. One message per status: "Uploading image…" once, then
 * silence on success, or "Image upload failed".
 */
export function AttachmentStatusAnnouncer({ label }: { label: string | null }) {
  const [text, setText] = useState('');
  useEffect(() => {
    const id = setTimeout(() => setText(label ?? ''), 50);
    return () => clearTimeout(id);
  }, [label]);
  return (
    <View className="sr-only" webProps={{ role: 'status', 'aria-live': 'polite' }}>
      {text}
    </View>
  );
}
